import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router';

class Submission extends React.Component {
  constructor(props) {
    super(props);
    this.displayName = 'Submission';

    this.state = {

    	email : '',
    	submit_success : false,
    	submit_error : false

    	}
	}

	render() {
		return
		(
			<div>
			{(()=>{
				if(submit_success==false && !submit_error==false) {
					return (<div>COOL!</div>);
				}
			})()}
			</div>
			)
	}
}

export default connect()(Submission);


// WEBPACK FOOTER //
// ./src/browser/components/recovery/submission.js